import { RSAA } from 'redux-api-middleware';

const authMiddleware = (getAccessTokenSilently) => (store) => (next) => async (action) => {
  const callApi = RSAA ? action[RSAA] : null;

  const accessToken = await getAccessTokenSilently();

  // Check if this action is a redux-api-middleware action.
  if (callApi) {
    // Inject the Authorization header from localStorage.
    callApi.headers = Object.assign({}, callApi.headers, {
      Authorization: `Bearer ${accessToken}` || ''
    });
  }

  // Pass the FSA to the next action.
  return next(action);
};

export default authMiddleware;
